import React from "react";
import clsx from "clsx";
import { Spinner } from "@chakra-ui/react";

type ButtonProps = {
  children: React.ReactNode | string;
  variant:
    | "primary"
    | "disabled"
    | "outlined"
    | "danger"
    | "gray"
    | "text-only";
  size: "fit" | "full";
  isLoading?: boolean;
  disabled?: boolean;
  extra?: string;
  icon?: React.ReactNode;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
};

const Button: React.FC<ButtonProps> = (props) => {
  const {
    children,
    variant,
    size,
    isLoading,
    disabled,
    extra,
    icon,
    type,
    onClick,
  } = props;

  return (
    <button
      type={type}
      className={clsx(
        extra,
        "flex items-center justify-center gap-2",
        "rounded-xl text-base font-medium",
        "transition duration-200",
        [
          variant === "primary" && [
            "bg-brand-500 text-white hover:bg-brand-600 dark:text-white",
          ],
          variant === "disabled" && [
            "cursor-not-allowed",
            "bg-gray-200 text-gray-400",
          ],
          variant === "outlined" && [
            "border",
            "border-brand-500 bg-white !text-brand-500 hover:bg-brand-500 hover:!text-white active:bg-brand-600",
            "dark:bg-navy-700 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200",
          ],
          variant === "danger" && [
            "bg-red-500 hover:bg-red-600 active:bg-red-700",
            "dark:bg-red-400 dark:hover:bg-red-300 dark:active:bg-red-200",
          ],
          variant === "gray" && [
            "bg-lightPrimary px-4 text-brand-500 hover:bg-gray-100 active:bg-gray-200",
            "dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20",
          ],
          variant === "text-only" && [
            "bg-transparent text-brand-500 hover:underline active:underline",
            "dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20",
          ],
        ],
        "disabled:cursor-not-allowed",
        size === "fit" &&
          "flex items-center justify-center !rounded-[20px] px-4 py-2",
        size === "full" && "mt-2 w-full py-[12px]",
        (isLoading || disabled) && [
          "cursor-not-allowed",
          "bg-opacity-50 opacity-50",
        ],
        (isLoading || disabled) && size === "full" && ["!pb-[5px] !pt-[12px]"],
        (isLoading || disabled) &&
          size === "fit" && ["!pb-[8px] !pt-[10px]", "!w-20"]
      )}
      onClick={onClick}
    >
      {icon && icon}
      {isLoading ? <Spinner size="md" /> : children}
    </button>
  );
};

export default Button;
